import Bowser from "bowser";

export const isPwa = window.matchMedia('(display-mode: standalone)').matches;
export const isWebkit = window.webkit && window.navigator && window.navigator.standalone;
export const isIosApp = window.webkit && window.webkit.messageHandlers && window.navigator && window.navigator.standalone;
export const isAndroidApp = document.referrer.includes('android-app://');

// Bowser parsing is computed once per session — UA + display-mode flags don't
// change after page load. Shared instance also consumed by store/modules/browser.js
// so the entire app gets one parser, not two.
export const bowserParser = Bowser.getParser((window.navigator && window.navigator.userAgent) || '');

const _osMap = { 'Android': 'android', 'iOS': 'ios', 'Windows': 'windows', 'macOS': 'macos', 'Linux': 'linux' };
const _browserMap = { 'Microsoft Edge': 'edge', 'Firefox': 'firefox', 'Chrome': 'chrome', 'Chromium': 'chrome', 'Safari': 'safari' };

const APP_TYPE = (isIosApp || isAndroidApp) ? 'store' : ((isPwa || isWebkit) ? 'pwa' : 'browser');
const OS = _osMap[bowserParser.getOSName()] || 'other';
const BROWSER = (isIosApp || isAndroidApp) ? null : (_browserMap[bowserParser.getBrowserName()] || 'other');

/**
 * Distribution channel for analytics. Sent in POST /push/token as `appType`.
 *  - 'store'   — native app (PWABuilder iOS WKWebView or Android wrapper)
 *  - 'pwa'     — installed PWA, display-mode standalone (Add to Home Screen)
 *  - 'browser' — regular browser visit, no install
 */
export function detectAppType() { return APP_TYPE; }

/**
 * Operating system the user is on. Independent from `platform` (which codes
 * the SDK). Allowed values match the enum in `clients_push_tokens.os`.
 */
export function detectOs() { return OS; }

/**
 * Browser vendor. Returns null inside native wrappers (PWABuilder iOS /
 * Android wrapper) where "browser" doesn't apply.
 */
export function detectBrowser() { return BROWSER; }
